import "./BackComponent.scss";
import IconButtonComponent from "../icon-button/IconButtonComponent";
import {ImageConfig} from "../../../constants";

interface BackComponentProps {
    onClick?: () => void;
}

const BackComponent = (props: BackComponentProps) => {

    const {onClick} = props;

    return (
        <div className={'back-component'} onClick={onClick}>
            <IconButtonComponent>
                <ImageConfig.BackNavCircleIcon/>
            </IconButtonComponent>
            <div className={'back-label'}>
                Back
            </div>
        </div>
    );

};

export default BackComponent;
